import module from 'finanzas/module.js'
import template from './template.html'
import * as moment from 'moment'

export class FinancesServiciosagregadosListaItemComponent {
  data
  editando = false
  onChange

  constructor ($http) {
    this.$http = $http
  }

  $onChanges (changes) {
    if (changes.data) {
      this.data = Object.assign({}, this.data)
    }
  }

  actualizar () {
    this.$http.get('/kendu/empleados/servicios/buscar', {
        params: {
          empresa: this.data.ID_Empresa,
          empleado: this.data.ID_Empleado,
          ID_Moneda: this.data.Tipo_Moneda,
          buscar: {
            folios: [this.data.Folio],
          },
          limite: 0,
        },
      })
      .then((response) => {
        let servicio = response.data[0]
        this.data.Codigo_Movimiento = servicio.Codigo
        this.data.Concepto = servicio.Concepto
        this.data.Fecha_Movimiento = moment(servicio.Fecha).toDate()
        this.data.Importe = Number(servicio.Importe)
        this.data.Naturaleza = servicio.Naturaleza
        this.data.Notas = servicio.Notas
      })
  }

  cerrar () {
    this.editando = false
    this.onChange({$event: {detail: this.data}})
  }
}

module.component('financesServiciosagregadosListaItem', {
  controller: FinancesServiciosagregadosListaItemComponent,
  template,
  bindings: {
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/serviciosagregados/lista/item/component.js